'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _Array$from = require('@babel/runtime-corejs3/core-js-stable/array/from');
var _Symbol = require('@babel/runtime-corejs3/core-js-stable/symbol');
var _getIteratorMethod = require('@babel/runtime-corejs3/core-js/get-iterator-method');
var _Array$isArray = require('@babel/runtime-corejs3/core-js-stable/array/is-array');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _JSON$stringify = require('@babel/runtime-corejs3/core-js-stable/json/stringify');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _Set = require('@babel/runtime-corejs3/core-js-stable/set');
require('../error/index.js');
require('../utils/index.js');
var attribute_model = require('./attribute.model.js');
var graphStudioError_model = require('../error/graph-studio-error.model.js');
var formatValidator = require('../utils/format-validator.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _Array$from__default = /*#__PURE__*/_interopDefaultLegacy(_Array$from);
var _Symbol__default = /*#__PURE__*/_interopDefaultLegacy(_Symbol);
var _getIteratorMethod__default = /*#__PURE__*/_interopDefaultLegacy(_getIteratorMethod);
var _Array$isArray__default = /*#__PURE__*/_interopDefaultLegacy(_Array$isArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _JSON$stringify__default = /*#__PURE__*/_interopDefaultLegacy(_JSON$stringify);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _Set__default = /*#__PURE__*/_interopDefaultLegacy(_Set);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol__default["default"] && _getIteratorMethod__default["default"](r) || r["@@iterator"]; if (!t) { if (_Array$isArray__default["default"](r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context5; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty__default["default"](_context5 = {}.toString.call(r)).call(_context5, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from__default["default"](r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/**
 * GSQL Vertex json representation interface following the format:
 *   {
 *     "Name": string,
 *     "PrimaryId": GSQLAttributeJson,
 *     "Attributes": GSQLAttributeJson[],
 *     "Config": { ... }
 *   }
 *
 * @export
 * @interface GSQLVertexJson
 */

/**
 * Vertex describes a vertex type in graph schema, including the vertex type's name,
 * primary_id attributes, and so on.
 *
 * @export
 * @class Vertex
 */
var Vertex = /*#__PURE__*/function () {
  /**
   * Creates an instance of Vertex.
   *
   * @memberof Vertex
   */
  function Vertex() {
    _classCallCheck__default["default"](this, Vertex);
    this.name = '';
    this.primaryId = new attribute_model.Attribute();
    this.attributes = [];
    this.config = {
      STATS: 'OUTDEGREE_BY_EDGETYPE'
    };
    this.style = undefined;
    this.isLocal = true;
    this.usage = undefined;
  }

  /**
   * Clone one vertex.
   *
   * @returns {Vertex}
   * @memberof Vertex
   */
  return _createClass__default["default"](Vertex, [{
    key: "clone",
    value: function clone() {
      var _context;
      var vertex = new Vertex();
      vertex.name = this.name;
      vertex.primaryId = this.primaryId.clone();
      vertex.config = JSON.parse(_JSON$stringify__default["default"](this.config));
      if (this.style !== undefined) {
        vertex.style = this.style.clone();
      }
      _forEachInstanceProperty__default["default"](_context = this.attributes).call(_context, function (attribute) {
        vertex.attributes.push(attribute.clone());
      });
      vertex.isLocal = this.isLocal;
      vertex.usage = this.usage;
      return vertex;
    }

    /**
     * Load Vertex from GSQL Vertex json representation.
     *
     * @param {GSQLVertexJson} vertexJson GSQL Vertex json representation
     * @returns {Vertex}
     * @memberof Vertex
     */
  }, {
    key: "loadFromGSQLJson",
    value: function loadFromGSQLJson(vertexJson) {
      var _context2;
      // Name
      this.name = vertexJson.Name;

      // PrimaryId
      this.primaryId.loadFromGSQLJson(vertexJson.PrimaryId);

      // Attributes
      this.attributes = _mapInstanceProperty__default["default"](_context2 = vertexJson.Attributes).call(_context2, function (attr) {
        var attribute = new attribute_model.Attribute();
        attribute.loadFromGSQLJson(attr);
        return attribute;
      });

      // Config
      this.config = vertexJson.Config;

      // Is local
      this.isLocal = !!vertexJson.IsLocal;

      // Graph list that global vertex type is used.
      if (vertexJson.Usage) {
        this.usage = vertexJson.Usage;
      }

      // Do semantic check
      var semanticResult = this.semanticCheck();
      if (!semanticResult.success) {
        throw new graphStudioError_model.GraphStudioError(semanticResult.message);
      }
      return this;
    }

    /**
     * Dump Vertex into GSQL Vertex json representation.
     *
     * @returns {GSQLVertexJson}
     * @memberof Vertex
     */
  }, {
    key: "dumpToGSQLJson",
    value: function dumpToGSQLJson() {
      var _context3;
      var vertexJson = {
        Name: this.name,
        PrimaryId: this.primaryId.dumpToGSQLJson(),
        Attributes: _mapInstanceProperty__default["default"](_context3 = this.attributes).call(_context3, function (attr) {
          return attr.dumpToGSQLJson();
        }),
        Config: this.config
      };

      // Update IsLocal flag
      if (this.isLocal) {
        vertexJson.IsLocal = true;
      }
      if (this.usage) {
        vertexJson.Usage = this.usage;
      }
      return vertexJson;
    }

    /**
     * Get the vertex visualization information.
     *
     * @returns {NodeVis}
     * @memberof Vertex
     */
  }, {
    key: "getVis",
    value: function getVis() {
      var _context4;
      var vis = {
        attributes: {},
        vertex_id: this.name,
        vertex_type: this.name,
        other: {}
      };
      // primary id, attributes name and type
      vis.attributes['(PRIMARY ID) ' + this.primaryId.name] = this.primaryId.type.name;
      _forEachInstanceProperty__default["default"](_context4 = this.attributes).call(_context4, function (attr) {
        return vis.attributes[attr.name] = attr.type.toString();
      });
      // visualization style
      if (this.style !== undefined) {
        vis.style = this.style.dumpToDBJson();
        vis.other['fixed'] = true;
      }
      return vis;
    }

    /**
     * Semantic check vertex type to be valid vertex type.
     *
     * @returns {ValidateResult}
     * @memberof Vertex
     */
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      // 1. Invalid vertex type name.
      var validateName = formatValidator.FormatValidator.isName(this.name);
      if (!validateName.success) {
        return {
          success: false,
          message: "Invalid vertex name \"".concat(this.name, "\". ") + validateName.message
        };
      }
      // 2. Primary ID must has valid name
      validateName = formatValidator.FormatValidator.isName(this.primaryId.name);
      if (!validateName.success) {
        return {
          success: false,
          message: "Invalid PrimaryID name \"".concat(this.primaryId.name, "\". ") + validateName.message
        };
      }
      // 3. Primary ID name cannot be same with vertex type name.
      if (this.primaryId.name === this.name) {
        return {
          success: false,
          message: "Vertex type name \"".concat(this.name, "\" cannot be used as its primary ID name.")
        };
      }
      // 4. Attribute name cannot be same with vertex type name.
      var _iterator = _createForOfIteratorHelper(this.attributes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _attr = _step.value;
          if (_attr.name === this.name) {
            return {
              success: false,
              message: "Vertex type name \"".concat(this.name, "\" cannot be used as its attributes' names.")
            };
          }
        }
        // 5. Attribute name cannot be duplicated.
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var names = new _Set__default["default"]();
      for (var i = 0; i < this.attributes.length; i++) {
        if (names.has(this.attributes[i].name)) {
          return {
            success: false,
            message: "More than one attributes have name \"".concat(this.attributes[i].name, "\".")
          };
        }
        names.add(this.attributes[i].name);
      }

      // 6. Attributes must be valid.
      var _iterator2 = _createForOfIteratorHelper(this.attributes),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var attribute = _step2.value;
          var validResult = attribute.semanticCheck();
          if (!validResult.success) {
            return validResult;
          }
        }

        // 7. If primary id is used as an attribute, its name cannot be used as annther attribute's name.
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (this.config.PRIMARY_ID_AS_ATTRIBUTE === true) {
        var _iterator3 = _createForOfIteratorHelper(this.attributes),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var attr = _step3.value;
            if (attr.name === this.primaryId.name) {
              return {
                success: false,
                message: "Primary ID \"".concat(this.primaryId.name, "\" is used as an attribute, ") + "so \"".concat(this.primaryId.name, "\" cannot be used as another attribute's name.")
              };
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      return {
        success: true
      };
    }
  }]);
}();

exports.Vertex = Vertex;
